import {
  IncomingMessage,
  ListenerEvent,
  MessageHandler
} from '@carvana/merch-native';
import { useMemo } from 'react';
import useBudgetTradeIn from '~/hooks/srp/useBudgetTradeIn';
import { ListenerEventType } from './constants';

type ToggleTradePayload = {
  isTradeInApplied: boolean;
};

function isToggleTradeMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, ToggleTradePayload> {
  return message.event === ListenerEvent.TradeInToggled;
}

export default function useToggleTradeHandler(): MessageHandler<
  ListenerEventType,
  ToggleTradePayload
> {
  const toggleTrade = useBudgetTradeIn();

  return useMemo(
    () =>
      new MessageHandler(isToggleTradeMessage, message => {
        toggleTrade(message.payload.isTradeInApplied);
      }),
    [toggleTrade]
  );
}
